import { Button, COMMON_STYLES } from '@dehaat/dds';
import useTranslation from 'next-translate/useTranslation';
import { useMemo, useState } from 'react';
interface SharePaymentLinkSheetProps {
  onClose: VoidFunction;
  onSubmit: (phoneNumber: string) => void;
}
const SharePaymentLinkSheet = ({
  onClose,
  onSubmit
}: SharePaymentLinkSheetProps) => {
  const {
    t
  } = useTranslation('payments');
  const [phoneNumber, setPhoneNumber] = useState<string>('');
  const [showError, setShowError] = useState<boolean>(false);
  const isPhoneNumberValid = useMemo(() => phoneNumber.length === 10 && /^\d+$/.test(phoneNumber), [phoneNumber]);
  return <div className="z-50 fixed inset-0" data-sentry-component="SharePaymentLinkSheet" data-sentry-source-file="SharePaymentLinkSkheet.tsx">
      {/* Dim Background */}
      <div className="absolute inset-0 bg-black bg-opacity-50" onClick={onClose} />

      {/* Bottom Sheet */}
      <div className="bottom-0 z-50 absolute inset-x-0 bg-white shadow-lg p-4 rounded-t-2xl">
        {/* Shadow on Upper Edge */}
        <div className="bg-gray-300 mx-auto mb-4 rounded-full w-12 h-1"></div>

        {/* Header */}
        <div className="flex justify-between items-center">
          <h2 className="font-bold text-lg">{t('enter_phone_number')}</h2>
          <button onClick={onClose} className="flex justify-center items-center bg-[#E6EBF0] rounded-full w-8 h-8 text-lg">
            ✕
          </button>
        </div>

        {/* Input Field */}
        <div className="mt-4">
          <div className="flex items-stretch border rounded overflow-hidden">
            {/* Prefix */}
            <div className="flex justify-center items-center bg-[#E6EBF0] px-3">
              <span className="font-medium text-gray-700 text-sm">+91</span>
            </div>
            {/* Input */}
            <input type="tel" className="flex-1 p-2 outline-none" placeholder={t('enter_phone_number')} value={phoneNumber} maxLength={10} onChange={e => setPhoneNumber(e.target.value)} />
          </div>
          {/* Validation Error */}
          {showError && !isPhoneNumberValid && phoneNumber.length > 0 && <div className="mt-2">
              <p className="text-red-500 text-sm">
                {t('invalid_phone_number')}
              </p>
            </div>}
        </div>

        {/* Button */}
        <Button text={t('confirm_and_proceed')} buttonStyle={[COMMON_STYLES.mt1, COMMON_STYLES['pv3/2']]} onClick={() => {
        if (isPhoneNumberValid) {
          setShowError(false);
          onSubmit(phoneNumber);
        } else {
          setShowError(true);
        }
      }} data-sentry-element="Button" data-sentry-source-file="SharePaymentLinkSkheet.tsx" />
      </div>
    </div>;
};
export default SharePaymentLinkSheet;